// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as HyperLogger$OrcaPaymentPage from "../hyper-log-catcher/HyperLogger.bs.js";
import * as PaymentHelpers$OrcaPaymentPage from "../Utilities/PaymentHelpers.bs.js";
import * as PaymentHelpersV2$OrcaPaymentPage from "../Utilities/PaymentHelpersV2.bs.js";

function sendPromiseData(promise, key) {
  var executePromise = async function () {
    var response;
    try {
      response = await promise;
    }
    catch (exn){
      response = null;
    }
    return Utils$OrcaPaymentPage.messageParentWindow(undefined, [
                [
                  "response",
                  response
                ],
                [
                  "data",
                  key
                ]
              ]);
  };
  executePromise();
}

function useMessageHandler(getMessageHandler) {
  React.useEffect((function () {
          var messageHandler = getMessageHandler();
          var setupMessageListener = function (param) {
            window.addEventListener("message", messageHandler);
            Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                    "preMountLoaderIframeMountedCallback",
                    true
                  ]]);
          };
          var cleanupMessageListener = function (param) {
            window.removeEventListener("message", messageHandler);
            Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                    "preMountLoaderIframeUnMount",
                    true
                  ]]);
          };
          var handleCleanUpEventListener = function (ev) {
            var dict = Utils$OrcaPaymentPage.getDictFromJson(Utils$OrcaPaymentPage.safeParse(ev.data));
            if (Core__Option.isSome(dict["cleanUpPreMountLoaderIframe"])) {
              return cleanupMessageListener();
            }
            
          };
          var handleResendMountedCallback = function (ev) {
            var dict = Utils$OrcaPaymentPage.getDictFromJson(Utils$OrcaPaymentPage.safeParse(ev.data));
            if (Core__Option.isSome(dict["requestPreMountLoaderMountedCallback"])) {
              return Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                            "preMountLoaderIframeMountedCallback",
                            true
                          ]]);
            }
            
          };
          window.addEventListener("message", handleCleanUpEventListener);
          window.addEventListener("message", handleResendMountedCallback);
          setupMessageListener();
          return (function () {
                    cleanupMessageListener();
                    window.removeEventListener("message", handleCleanUpEventListener);
                    window.removeEventListener("message", handleResendMountedCallback);
                  });
        }), []);
}

function getMessageHandlerV1Elements(sdkAuthorization, clientSecret, publishableKey, logger, customPodUri, endpoint, merchantHostname, isTestModeOpt, isSdkParamsEnabledOpt) {
  var isTestMode = isTestModeOpt !== undefined ? isTestModeOpt : false;
  var isSdkParamsEnabled = isSdkParamsEnabledOpt !== undefined ? isSdkParamsEnabledOpt : false;
  var match;
  if (isTestMode || isSdkParamsEnabled) {
    var mockResponse = {};
    match = [
      Promise.resolve(mockResponse),
      Promise.resolve(mockResponse),
      Promise.resolve(mockResponse),
      Promise.resolve(mockResponse)
    ];
  } else {
    match = [
      PaymentHelpers$OrcaPaymentPage.fetchPaymentMethodList(Caml_option.some(sdkAuthorization), clientSecret, publishableKey, logger, customPodUri, endpoint),
      PaymentHelpers$OrcaPaymentPage.fetchCustomerPaymentMethodList(clientSecret, publishableKey, logger, customPodUri, endpoint, undefined, Caml_option.some(sdkAuthorization)),
      PaymentHelpers$OrcaPaymentPage.fetchSessions(clientSecret, publishableKey, undefined, undefined, logger, customPodUri, endpoint, undefined, merchantHostname, Caml_option.some(sdkAuthorization)),
      PaymentHelpers$OrcaPaymentPage.fetchBlockedBins(sdkAuthorization, clientSecret, publishableKey, logger, customPodUri, endpoint)
    ];
  }
  var blockedBinsPromise = match[3];
  var sessionTokensPromise = match[2];
  var customerPaymentMethodsPromise = match[1];
  var paymentMethodsPromise = match[0];
  return function (ev) {
    var dict = Utils$OrcaPaymentPage.getDictFromJson(Utils$OrcaPaymentPage.safeParse(ev.data));
    if (Utils$OrcaPaymentPage.isKeyPresentInDict(dict, "sendPaymentMethodsResponse")) {
      return sendPromiseData(paymentMethodsPromise, "payment_methods");
    } else if (Utils$OrcaPaymentPage.isKeyPresentInDict(dict, "sendCustomerPaymentMethodsResponse")) {
      return sendPromiseData(customerPaymentMethodsPromise, "customer_payment_methods");
    } else if (Utils$OrcaPaymentPage.isKeyPresentInDict(dict, "sendSessionTokensResponse")) {
      return sendPromiseData(sessionTokensPromise, "session_tokens");
    } else if (Utils$OrcaPaymentPage.isKeyPresentInDict(dict, "sendBlockedBinsResponse")) {
      return sendPromiseData(blockedBinsPromise, "blocked_bins");
    } else {
      return ;
    }
  };
}

function getMessageHandlerV2PMM(pmSessionId, pmClientSecret, publishableKey, profileId, logger, customPodUri, endpoint) {
  var listPromise = PaymentHelpersV2$OrcaPaymentPage.fetchPaymentManagementList(pmSessionId, pmClientSecret, publishableKey, profileId, endpoint, Caml_option.some(logger), customPodUri);
  return function (ev) {
    var dict = Utils$OrcaPaymentPage.getDictFromJson(Utils$OrcaPaymentPage.safeParse(ev.data));
    if (Utils$OrcaPaymentPage.isKeyPresentInDict(dict, "sendPaymentManagementListResponse")) {
      return sendPromiseData(listPromise, "payment_management_list");
    }
    
  };
}

function PreMountLoader$PreMountLoaderForElements(props) {
  var __isSdkParamsEnabled = props.isSdkParamsEnabled;
  var __isTestMode = props.isTestMode;
  var customPodUri = props.customPodUri;
  var merchantHostname = props.merchantHostname;
  var endpoint = props.endpoint;
  var clientSecret = props.clientSecret;
  var sdkAuthorization = props.sdkAuthorization;
  var publishableKey = props.publishableKey;
  var logger = props.logger;
  var isTestMode = __isTestMode !== undefined ? __isTestMode : false;
  var isSdkParamsEnabled = __isSdkParamsEnabled !== undefined ? __isSdkParamsEnabled : false;
  useMessageHandler(function () {
        return getMessageHandlerV1Elements(sdkAuthorization, clientSecret, publishableKey, logger, customPodUri, endpoint, merchantHostname, isTestMode, isSdkParamsEnabled);
      });
  return null;
}

var PreMountLoaderForElements = {
  make: PreMountLoader$PreMountLoaderForElements
};

function PreMountLoader$PreMountLoaderForPMMElements(props) {
  var profileId = props.profileId;
  var publishableKey = props.publishableKey;
  var pmClientSecret = props.pmClientSecret;
  var pmSessionId = props.pmSessionId;
  var customPodUri = props.customPodUri;
  var endpoint = props.endpoint;
  var logger = props.logger;
  useMessageHandler(function () {
        return getMessageHandlerV2PMM(pmSessionId, pmClientSecret, publishableKey, profileId, logger, customPodUri, endpoint);
      });
  return null;
}

var PreMountLoaderForPMMElements = {
  make: PreMountLoader$PreMountLoaderForPMMElements
};

function PreMountLoader(props) {
  var __isSdkParamsEnabled = props.isSdkParamsEnabled;
  var __isTestMode = props.isTestMode;
  var customPodUri = props.customPodUri;
  var endpoint = props.endpoint;
  var clientSecret = props.clientSecret;
  var publishableKey = props.publishableKey;
  var isTestMode = __isTestMode !== undefined ? __isTestMode : false;
  var isSdkParamsEnabled = __isSdkParamsEnabled !== undefined ? __isSdkParamsEnabled : false;
  var logger = HyperLogger$OrcaPaymentPage.make(props.sessionId, "Loader", clientSecret, publishableKey, undefined);
  if (props.hyperComponentName === "Elements") {
    return React.createElement(PreMountLoader$PreMountLoaderForElements, {
                logger: logger,
                publishableKey: publishableKey,
                sdkAuthorization: props.sdkAuthorization,
                clientSecret: clientSecret,
                endpoint: endpoint,
                merchantHostname: props.merchantHostname,
                customPodUri: customPodUri,
                isTestMode: isTestMode,
                isSdkParamsEnabled: isSdkParamsEnabled
              });
  } else {
    return React.createElement(PreMountLoader$PreMountLoaderForPMMElements, {
                logger: logger,
                endpoint: endpoint,
                customPodUri: customPodUri,
                pmSessionId: props.pmSessionId,
                pmClientSecret: props.pmClientSecret,
                publishableKey: publishableKey,
                profileId: props.profileId
              });
  }
}

var make = PreMountLoader;

export {
  sendPromiseData ,
  useMessageHandler ,
  getMessageHandlerV1Elements ,
  getMessageHandlerV2PMM ,
  PreMountLoaderForElements ,
  PreMountLoaderForPMMElements ,
  make ,
}
/* react Not a pure module */
